import { render, staticRenderFns } from "./IcdHeader.vue?vue&type=template&id=5ed4a983&scoped=true&"
import script from "./IcdHeader.vue?vue&type=script&lang=js&"
export * from "./IcdHeader.vue?vue&type=script&lang=js&"
import style0 from "./IcdHeader.vue?vue&type=style&index=0&id=5ed4a983&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4a983",
  null
  
)

export default component.exports